import { render, staticRenderFns } from "./platformDetail.vue?vue&type=template&id=8db8c370&"
import script from "./platformDetail.vue?vue&type=script&lang=js&"
export * from "./platformDetail.vue?vue&type=script&lang=js&"
import style0 from "./platformDetail.vue?vue&type=style&index=0&id=8db8c370&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8db8c370')) {
      api.createRecord('8db8c370', component.options)
    } else {
      api.reload('8db8c370', component.options)
    }
    module.hot.accept("./platformDetail.vue?vue&type=template&id=8db8c370&", function () {
      api.rerender('8db8c370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/revenueSsharing/platformDetail.vue"
export default component.exports